export const DesignLiveLogo = () => (
    <svg
        width="140"
        height="25"
        viewBox="0 0 323 58"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <mask id="mask0" maskUnits="userSpaceOnUse" x="75" y="14" width="32" height="34">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M75 14V48H88.237C99.7155 48 107 41.3695 107 31C107 20.6295 99.7155 14 88.237 14H75ZM79.0441 17.6917H88.237C97.7562 17.6917 102.755 22.9859 102.755 31C102.755 38.9659 97.7562 44.3088 88.237 44.3088H79.0441V17.6917Z"
                fill="white"
            />
        </mask>
        <g mask="url(#mask0)">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M72.377 50.4638H109.623V11.5363H72.377V50.4638Z"
                fill="#221C1C"
            />
        </g>
        <mask id="mask1" maskUnits="userSpaceOnUse" x="111" y="23" width="24" height="25">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M111 35.513C111 42.9495 116.219 48 123.563 48C127.21 48 130.673 47.1115 133.767 44.2437L131.669 41.6552C129.544 43.5333 126.868 44.676 123.799 44.676C119.314 44.676 115.565 42.0099 115.013 36.8318H134.922C134.974 36.4005 135 35.8937 135 35.4115C134.948 28.1021 130.068 23 123.328 23C116.246 23 111 28.1521 111 35.513ZM123.25 26.376C127.472 26.376 130.515 29.2688 131.013 33.7615H115.066C115.695 29.4214 118.659 26.376 123.25 26.376Z"
                fill="white"
            />
        </mask>
        <g mask="url(#mask1)">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M108.333 50.6041H137.667V20.3958H108.333V50.6041Z"
                fill="#221C1C"
            />
        </g>
        <mask id="mask2" maskUnits="userSpaceOnUse" x="137" y="23" width="22" height="25">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M137.921 30.2995C137.921 33.8854 140.631 36.3016 146.402 36.962L149.463 37.2932C153.095 37.701 154.828 38.8698 154.828 40.8026C154.828 43.3458 152.091 44.6943 147.756 44.6943C143.422 44.6943 140.82 43.4995 138.869 42.074L137 44.9234C140.251 47.2375 144.396 48 147.703 48C154.612 48 159 45.1266 159 40.5484C159 36.6068 155.831 34.4958 150.385 33.8344L147.35 33.4792C143.991 33.0969 142.121 32.1057 142.121 30.0964C142.121 27.7557 144.532 26.3068 148.189 26.3068C151.658 26.3068 154.937 27.5021 156.589 28.5703L158.351 25.6193C155.885 24.0682 152.2 23 148.163 23C142.012 23 137.921 25.7474 137.921 30.2995Z"
                fill="white"
            />
        </mask>
        <g mask="url(#mask2)">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M134.25 50.6041H161.75V20.3958H134.25V50.6041Z"
                fill="#221C1C"
            />
        </g>
        <mask id="mask3" maskUnits="userSpaceOnUse" x="162" y="14" width="4" height="34">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M162 16.5947C162 18.0638 162.853 19.165 163.99 19.165C165.109 19.165 166 18.0638 166 16.5947C166 15.1256 165.109 14 163.99 14C162.853 14 162 15.1256 162 16.5947ZM162.568 48H165.412V24.8191H162.568V48Z"
                fill="white"
            />
        </mask>
        <g mask="url(#mask3)">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M160 50.5373H168V11.4627H160V50.5373Z"
                fill="#221C1C"
            />
        </g>
        <mask id="mask4" maskUnits="userSpaceOnUse" x="171" y="24" width="24" height="34">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M171 35.9406C171 43.0065 176.09 47.9061 182.762 47.9061C186.598 47.9061 189.433 46.3801 191.238 43.9423V46.3309C191.238 51.7709 187.577 54.6523 182.436 54.6523C179.226 54.6523 176.342 53.5932 174.085 51.9181L172.43 54.8735C174.837 56.843 178.649 58 182.436 58C189.784 58 195 53.7901 195 46.1827V24.4679H191.238V27.9638C189.433 25.5508 186.598 24 182.762 24C176.09 24 171 28.899 171 35.9406ZM174.812 35.9406C174.812 31.239 178.146 27.4467 183.187 27.4467C188.079 27.4467 191.564 31.14 191.564 35.9406C191.564 40.7914 188.079 44.4589 183.187 44.4589C178.146 44.4589 174.812 40.6676 174.812 35.9406Z"
                fill="white"
            />
        </mask>
        <g mask="url(#mask4)">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M168.391 60.5373H197.609V21.4627H168.391V60.5373Z"
                fill="#221C1C"
            />
        </g>
        <mask id="mask5" maskUnits="userSpaceOnUse" x="200" y="23" width="22" height="25">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M203.777 26.9856V23.4915H200V48H203.829V34.1809C203.829 29.5223 207.171 26.675 211.23 26.675C215.645 26.675 218.198 29.4181 218.198 34.0766V48H222V32.808C222 26.8819 217.891 23 211.919 23C208.959 23 205.744 24.0612 203.777 26.9856Z"
                fill="white"
            />
        </mask>
        <g mask="url(#mask5)">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M197.381 50.6596H224.619V20.3405H197.381V50.6596Z"
                fill="#221C1C"
            />
        </g>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M231 14V48H257V40.4711H239.366V14H231Z"
            fill="#221C1C"
        />
        <mask id="mask6" maskUnits="userSpaceOnUse" x="260" y="10" width="8" height="36">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M260 14.6005C260 17.1705 261.732 19.1535 264 19.1535C266.246 19.1535 268 17.1705 268 14.6005C268 12.007 266.246 10 264 10C261.732 10 260 12.007 260 14.6005ZM260.685 46H267.38V21.9915H260.685V46Z"
                fill="white"
            />
        </mask>
        <g mask="url(#mask6)">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M257.778 48.5H270.222V7.5H257.778V48.5Z"
                fill="#221C1C"
            />
        </g>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M289.963 23L284.597 39.3104L279.28 23H271L280.227 48H288.895L298 23H289.963Z"
            fill="#221C1C"
        />
        <mask id="mask7" maskUnits="userSpaceOnUse" x="299" y="22" width="24" height="26">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M299 35.1509C299 42.8444 304.045 48 311.483 48C315.854 48 319.451 46.5165 321.913 43.9516L317.037 39.2242C315.54 40.6323 313.633 41.3868 311.869 41.3868C309.262 41.3868 307.427 40.1302 306.799 37.4389H322.855C322.951 36.9113 323 35.8045 323 34.9995C322.976 27.28 318.17 22 311.145 22C303.951 22 299 27.381 299 35.1509ZM311.168 28.6881C313.365 28.6881 314.84 29.9958 315.443 32.4602H306.823C307.403 30.0213 308.827 28.6881 311.168 28.6881Z"
                fill="white"
            />
        </mask>
        <g mask="url(#mask7)">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M296.5 50.549H325.5V19.451H296.5V50.549Z"
                fill="#221C1C"
            />
        </g>
        <mask id="mask8" maskUnits="userSpaceOnUse" x="8" y="0" width="48" height="29">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.2395 1.19638C15.0139 2.44707 11.1877 4.62629 8 7.50045L19.2395 13.987L45.2565 29L56 22.7993C53.0987 9.75455 41.4544 0 27.5296 0C24.6491 0 21.8672 0.419182 19.2395 1.19638Z"
                fill="white"
            />
        </mask>
        <g mask="url(#mask8)">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.33325 31.6364H58.6666V-2.63635H5.33325V31.6364Z"
                fill="#87DDFD"
            />
        </g>
        <mask id="mask9" maskUnits="userSpaceOnUse" x="0" y="5" width="21" height="50">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 26.8229C0 35.3824 3.65566 43.0867 9.48758 48.4569C12.7348 51.4463 16.6569 53.7128 21 55V41.8V11.5378L9.69426 5C3.74132 10.3777 0 18.1628 0 26.8229Z"
                fill="white"
            />
        </mask>
        <g mask="url(#mask9)">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M-2.76318 57.6596H23.7631V2.34045H-2.76318V57.6596Z"
                fill="#015180"
            />
        </g>
        <mask id="mask10" maskUnits="userSpaceOnUse" x="41" y="38" width="19" height="18">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M41 51.1601C47.2968 54.1278 53.9071 55.3374 60 54.9202C56.1916 50.2828 54.1771 44.289 54.6962 38C49.3488 40.6247 44.4211 45.1189 41 51.1601Z"
                fill="white"
            />
        </mask>
        <g mask="url(#mask10)">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M38.2058 57.5758H62.794V35.4243H38.2058V57.5758Z"
                fill="#00B1FF"
            />
        </g>
        <mask id="mask11" maskUnits="userSpaceOnUse" x="20" y="22" width="36" height="34">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M45.003 27.9373L20 42.3137V54.8552C22.5257 55.5986 25.1984 56 27.9673 56C41.4431 56 52.6973 46.5292 55.387 33.9071C55.7871 32.0285 56 30.0808 56 28.084C56 25.9947 55.767 23.9588 55.3299 22L45.003 27.9373Z"
                fill="white"
            />
        </mask>
        <g mask="url(#mask11)">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.4285 58.5373H58.5713V19.4627H17.4285V58.5373Z"
                fill="#00B1FF"
            />
        </g>
        <path fillRule="evenodd" clipRule="evenodd" d="M21 42L45 26.5L21 11V42Z" fill="white" />
    </svg>
);
